import {Component, OnDestroy, OnInit} from '@angular/core'
import {ContextService} from '@app/core/services/context.service'
import {Subject} from 'rxjs'
import {takeUntil, tap} from 'rxjs/operators'

@Component({
  selector: 'default-domain-selector',
  templateUrl: './default-domain.component.html',
  standalone: false,
})
export class DefaultDomainComponent implements OnInit, OnDestroy {
  constructor(public context: ContextService) {}
  destroy$ = new Subject<boolean>()
  defaultDomain: string
  activeDomain: string

  ngOnInit() {
    this.defaultDomain = this.context.loginDomain
    this.context.activeDomain$
      .pipe(
        takeUntil(this.destroy$),
        tap((activeDomain) => (this.activeDomain = activeDomain)),
      )
      .subscribe()
  }

  selectDomain() {
    this.context.changeActiveDomain(this.defaultDomain)
  }

  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
